/**
 * Requests which don't relate to one entity
 */
import { Http } from 'Core/utils/axios'

export const retrieveLanguages = (): Promise<Entity[]> => Http.get('/languages')

export const retrieveUnitsOfMeasure = (): Promise<Entity[]> => Http.get('/units-of-measure')

export const retrieveCountries = (): Promise<CodeEntity[]> => Http.get('/countries')
